import React from "react";
import { SketchPicker } from "react-color";
import { Form, Label, Table } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import Can from "../Can";
import { UserInput } from "../../components";

const BrandSettingsFields = ({ values, errors, onChange, onColorChange, onFileChange, t }) => {
  return (
    <>
      <Form.Field>
        <label>{t("country").message || "Country"}</label>
        <UserInput type="text" name="country" onChange={onChange} placeholder={t("country").message || "Country"} value={values.country} />
      </Form.Field>
      <Form.Field>
        <Table celled>
          <Table.Body>
            <Table.Row>
              <Table.Cell content="{{.Appointment.VIN}}" />
              <Table.Cell content="{{.Appointment.WONr}}" />
            </Table.Row>
            <Table.Row>
              <Table.Cell content="{{.Appointment.CurrentKM}}" />
              <Table.Cell content="{{.Appointment.NextKM}}" />
            </Table.Row>
            <Table.Row>
              <Table.Cell content="{{.JobDate}}" />
              <Table.Cell content="{{.XentryJobID}}" />
            </Table.Row>
          </Table.Body>
        </Table>
      </Form.Field>
      <Form.Field>
        <label>{t("button_label").message || "Button label"}</label>
        <UserInput type="text" name="button_label" onChange={onChange} value={values.button_label} placeholder={t("button_label").message || "Button label"} />
        {errors.errorButtonLabelText && (
          <Label basic color="red" pointing>
            {errors.errorButtonLabelText}
          </Label>
        )}
      </Form.Field>
      <Form.Field>
        <label>{t("tablet_service_button_url").message || "Tablet Service button URL"}</label>
        <UserInput
          type="text"
          name="tablet_service_button_url"
          onChange={onChange}
          value={values.tablet_service_button_url}
          placeholder={t("tablet_service_button_url").message || "Tablet Service button URL"}
        />
        {errors.errorServiceButtonTabletURL && (
          <Label basic color="red" pointing>
            {errors.errorServiceButtonTabletURL}
          </Label>
        )}
      </Form.Field>
      <Form.Field>
        <label>{t("appointment_service_button_url").message || "Appointment service button URL"}</label>
        <UserInput
          type="text"
          name="servicebox_wo"
          onChange={onChange}
          value={values.servicebox_wo}
          placeholder={t("appointment_service_button_url").message || "Appointment service button URL"}
        />
        {errors.errorServiceboxWoText && (
          <Label basic color="red" pointing>
            {errors.errorServiceboxWoText}
          </Label>
        )}
      </Form.Field>
      <Form.Field>
        <label>{t("car_detail_service_button_url").message || "Car detail service button URL"}</label>
        <UserInput
          type="text"
          name="servicebox_vin"
          onChange={onChange}
          value={values.servicebox_vin}
          placeholder={t("car_detail_service_button_url").message || "Car detail service button URL"}
        />
        {errors.errorServiceboxVinText && (
          <Label basic color="red" pointing>
            {errors.errorServiceboxVinText}
          </Label>
        )}
      </Form.Field>
      <Form.Field>
        <label>{t("button_label_2").message || "Button label 2"}</label>
        <UserInput
          type="text"
          name="servicebox_wo_2_name"
          onChange={onChange}
          value={values.servicebox_wo_2_name}
          placeholder={t("button_label_2").message || "Button label 2"}
        />
      </Form.Field>
      <Form.Field>
        <label>{t("wo_detail_button_2_url").message || "WO Detail button 2 URL"}</label>
        <UserInput
          type="text"
          name="servicebox_wo_2"
          onChange={onChange}
          value={values.servicebox_wo_2}
          placeholder={t("wo_detail_button_2_url").message || "WO Detail button 2 URL"}
        />
        {errors.errorServiceboxWo2Text && (
          <Label basic color="red" pointing>
            {errors.errorServiceboxWo2Text}
          </Label>
        )}
      </Form.Field>
      <Can I="create" the="files">
        <Form.Field>
          {values && values.logo && <img src={values.logo} className="logo" alt="logo" />}
          <input id="newBrandFile" className="newBrandFileUploader" type="file" onChange={onFileChange} />
        </Form.Field>
      </Can>
      <Form.Field>
        <SketchPicker color={values.color} onChangeComplete={onColorChange} />
      </Form.Field>
    </>
  );
};

export default withTranslation()(BrandSettingsFields);
